import React, { useState, useEffect } from 'react';
import { useCart } from './CartContext';


// ------------------ RAW BUNDLES DATA ------------------

const bundleLengths = ['10′', '12′', '14′', '16′', '18′', '20′', '22′', '24′', '26′', '28′', '30′'];
const bundleStyles = [
  'Straight/Bodywave',
  'Deepwave/waterwave',
  'Cambodian Wavy',
  'Indian Curly',
  'Burmese Curls',
  '4B/4C',
];

// UPDATED raw bundle prices (all styles)
const bundlePrices = [
  // length: 10′
  // Straight/Bodywave already +500, others +600
  [1750, 1950, 1950, 1950, 1950, 1950],
  // 12′
  [1850, 2050, 2050, 2050, 2050, 2050],
  // 14′
  [2300, 2500, 2500, 2500, 2500, 2500],
  // 16′
  [2900, 3100, 3100, 3100, 3100, 3100],
  // 18′
  [3400, 3600, 3600, 3600, 3600, 3600],
  // 20′ (Straight/Bodywave +300, others +400)
  [3700, 4100, 4100, 4100, 4100, 4100],
  // 22′
  [4100, 4300, 4300, 4300, 4300, 4300],
  // 24′
  [4500, 4700, 4700, 4700, 4700, 4700],
  // 26′
  [5200, 5400, 5400, 5400, 5400, 5400],
  // 28′
  [5600, 5800, 5800, 5800, 5800, 5800],
  // 30′ (unchanged for all)
  [5800, 5900, 5900, 5900, 5900, 5900],
];


// ------------------ VIRGIN (REMY) BUNDLES DATA ------------------

const virginBundleLengths = ['12′', '14′', '16′', '18′', '20′', '22′', '24′'];
const virginBundleStyles = [
  'Straight/Bodywave',
  'Waterwave',
  'Kinky Straight',
  'Jerry Curls',
  'Kinky Curly',
];

const virginBundlePrices = [
  [950, 950, 950, 950, 950],      // 12′
  [1000, 1000, 1000, 1000, 1000], // 14′
  [1100, 1100, 1100, 1100, 1100], // 16′
  [1270, 1270, 1270, 1270, 1270], // 18′
  [1450, 1450, 1450, 1450, 1450], // 20′
  [1650, 1650, 1650, 1650, 1650], // 22′
  [1700, 1700, 1700, 1700, 1700], // 24′
];


// ------------------ VIRGIN (REMY) EXTENSIONS DATA ------------------

const virginExtLengths = ['12′', '14′', '16′', '18′', '20′', '22′', '24′', '26′'];
const virginExtStyles = [
  'Straight/Bodywave',
  'Deepwave/waterwave',
  'Cambodian Wavy',
  'Indian Curly',
  'Burmese Curls',
  '4B/4C',
  'Kinky Straight',
  'Yaki',
];

const virginMicroPrices = [
  [1350, 1450, 1450, 1450, 1450, 1450, 1450, 1450], // 12′
  [1500, 1650, 1650, 1650, 1650, 1650, 1650, 1650], // 14′
  [1700, 1750, 1750, 1750, 1750, 1750, 1750, 1750], // 16′
  [2000, 2100, 2100, 2100, 2100, 2100, 2100, 2100], // 18′
  [2150, 2200, 2200, 2200, 2200, 2200, 2200, 2200], // 20′
  [2500, 2600, 2600, 2600, 2600, 2600, 2600, 2600], // 22′
  [2800, 2900, 2900, 2900, 2900, 2900, 2900, 2900], // 24′
  [3250, 3350, 3350, 3350, 3350, 3350, 3350, 3350], // 26′
];

const virginClipPrices = virginMicroPrices;

const virginTapePrices = [
  [1350, 1350, 1350, 1350, 1350, 1350, 1350, 1350], // 12′
  [1500, 1500, 1500, 1500, 1500, 1500, 1500, 1500], // 14′
  [1700, 1700, 1700, 1700, 1700, 1700, 1700, 1700], // 16′
  [2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000], // 18′
  [2144, 2144, 2144, 2144, 2144, 2144, 2144, 2144], // 20′
  [2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500], // 22′
  [2800, 2800, 2800, 2800, 2800, 2800, 2800, 2800], // 24′
  [3250, 3250, 3250, 3250, 3250, 3250, 3250, 3250], // 26′
];


// ------------------ RAW EXTENSIONS DATA ------------------

const rawExtLengths = ['12′', '14′', '16′', '18′', '20′', '22′', '24′'];
const rawExtStyles = ['Straight', 'Wavy'];

const rawExtBasePrices = [
  1800, // 12′
  2200, // 14′
  2800, // 16′
  3350, // 18′
  3900, // 20′
  4350, // 22′
  4900, // 24′
];

const rawMicroPrices = rawExtBasePrices.map((p) => [p, p]);
const rawClipPrices = rawExtBasePrices.map((p) => [p, p]);
const rawTapePrices = rawExtBasePrices.map((p) => [p, p]);


// ------------------ VIRGIN (REMY) CLOSURES DATA (REGULAR) ------------------

const virginClosureLengths = ['12′', '14′', '16′', '18′'];
const virginClosureTypes = ['2x6', '5x5'];

const virginClosurePrices = [
  [650, 900],  // 12′
  [700, 1100], // 14′
  [750, 1300], // 16′
  [850, 1500], // 18′
];


// ------------------ RAW HD CLOSURES DATA ------------------

const rawHdClosureLengths = ['12′', '14′', '16′', '18′', '20′', '22′'];
const rawHdClosureTypes = ['2x6', '5x5', '7x7', '9x6', '13x4', '13x6'];

const rawHdClosurePrices = [
  [1500, 2220, 3120, 3500, 2700, 3120], // 12′
  [1600, 2475, 3500, 4000, 3120, 3500], // 14′
  [1875, 2740, 4000, 4550, 3450, 4000], // 16′
  [2070, 3000, 4550, 4900, 3900, 4550], // 18′
  [2370, 3390, 0,    0,    4420, 0   ], // 20′
  [2685, 3700, 0,    0,    0,    0   ], // 22′
];


// ------------------ VIRGIN HD CLOSURES DATA ------------------

const virginHdClosureLengths = ['12′', '14′', '16′', '18′', '20′', '22′'];
const virginHdClosureTypes = ['2x6', '5x5', '7x7', '9x6'];

const virginHdClosurePrices = [
  [1050, 1275, 1885, 2300], // 12′
  [1100, 1380, 2100, 2560], // 14′
  [1155, 1510, 2330, 2850], // 16′
  [1275, 1650, 2561, 2990], // 18′
  [1400, 1800, 2782, 0   ], // 20′
  [1590, 2100, 2990, 0   ], // 22′
];


// ------------------ HELPERS ------------------

function buildProducts(lengths, styles, prices, label, isClosure = false) {
  const products = [];
  for (let i = 0; i < lengths.length; i++) {
    for (let j = 0; j < styles.length; j++) {
      const price = prices[i][j];
      if (price && price > 0) {
        products.push({
          id: `${label}_${lengths[i].replace(/["′]/g, '')}_${styles[j]
            .replace(/\W/g, '')
            .toLowerCase()}`,
          name: isClosure
            ? `${lengths[i]} ${styles[j]} Closure`
            : `${lengths[i]} ${styles[j]} Bundle`,
          price,
        });
      }
    }
  }
  return products;
}

function buildOptions(lengths, styles, prices, label, isClosure = false) {
  const subcategories = {};
  for (let j = 0; j < styles.length; j++) {
    subcategories[styles[j]] = [];
    for (let i = 0; i < lengths.length; i++) {
      const price = prices[i][j];
      if (price && price > 0) {
        subcategories[styles[j]].push({
          length: lengths[i],
          price,
          id: `${label}_${lengths[i].replace(/["′]/g, '')}_${styles[j]
            .replace(/\W/g, '')
            .toLowerCase()}`,
          isClosure,
        });
      }
    }
  }
  return subcategories;
}


// ------------------ PRODUCTS ------------------

const rawBundles = buildProducts(bundleLengths, bundleStyles, bundlePrices, 'rawBundle');

const virginBundles = buildProducts(
  virginBundleLengths,
  virginBundleStyles,
  virginBundlePrices,
  'virginBundle'
);

const virginMicroProducts = buildProducts(
  virginExtLengths,
  virginExtStyles,
  virginMicroPrices,
  'virginMicro'
);
const virginClipProducts = buildProducts(
  virginExtLengths,
  virginExtStyles,
  virginClipPrices,
  'virginClip'
);
const virginTapeProducts = buildProducts(
  virginExtLengths,
  virginExtStyles,
  virginTapePrices,
  'virginTape'
);

const rawMicroProducts = buildProducts(
  rawExtLengths,
  rawExtStyles,
  rawMicroPrices,
  'rawMicro'
);
const rawClipProducts = buildProducts(
  rawExtLengths,
  rawExtStyles,
  rawClipPrices,
  'rawClip'
);
const rawTapeProducts = buildProducts(
  rawExtLengths,
  rawExtStyles,
  rawTapePrices,
  'rawTape'
);

const virginClosureProducts = buildProducts(
  virginClosureLengths,
  virginClosureTypes,
  virginClosurePrices,
  'virginClosure',
  true
);

const rawHdClosureProducts = buildProducts(
  rawHdClosureLengths,
  rawHdClosureTypes,
  rawHdClosurePrices,
  'rawHdClosure',
  true
);

const virginHdClosureProducts = buildProducts(
  virginHdClosureLengths,
  virginHdClosureTypes,
  virginHdClosurePrices,
  'virginHdClosure',
  true
);

const hairProducts = [
  ...rawBundles,
  ...virginBundles,
  ...virginMicroProducts,
  ...virginClipProducts,
  ...virginTapeProducts,
  ...rawMicroProducts,
  ...rawClipProducts,
  ...rawTapeProducts,
  ...virginClosureProducts,
  ...rawHdClosureProducts,
  ...virginHdClosureProducts,
];


// ------------------ OPTION DATA FOR UI ------------------

const RAW_BUNDLE_DATA = buildOptions(
  bundleLengths,
  bundleStyles,
  bundlePrices,
  'rawBundle'
);

const VIRGIN_BUNDLE_DATA = buildOptions(
  virginBundleLengths,
  virginBundleStyles,
  virginBundlePrices,
  'virginBundle'
);

const VIRGIN_MICRO_DATA = buildOptions(
  virginExtLengths,
  virginExtStyles,
  virginMicroPrices,
  'virginMicro'
);

const VIRGIN_CLIP_DATA = buildOptions(
  virginExtLengths,
  virginExtStyles,
  virginClipPrices,
  'virginClip'
);

const VIRGIN_TAPE_DATA = buildOptions(
  virginExtLengths,
  virginExtStyles,
  virginTapePrices,
  'virginTape'
);

const RAW_MICRO_DATA = buildOptions(
  rawExtLengths,
  rawExtStyles,
  rawMicroPrices,
  'rawMicro'
);

const RAW_CLIP_DATA = buildOptions(
  rawExtLengths,
  rawExtStyles,
  rawClipPrices,
  'rawClip'
);

const RAW_TAPE_DATA = buildOptions(
  rawExtLengths,
  rawExtStyles,
  rawTapePrices,
  'rawTape'
);

const VIRGIN_CLOSURE_DATA = buildOptions(
  virginClosureLengths,
  virginClosureTypes,
  virginClosurePrices,
  'virginClosure',
  true
);

const RAW_HD_CLOSURE_DATA = buildOptions(
  rawHdClosureLengths,
  rawHdClosureTypes,
  rawHdClosurePrices,
  'rawHdClosure',
  true
);

const VIRGIN_HD_CLOSURE_DATA = buildOptions(
  virginHdClosureLengths,
  virginHdClosureTypes,
  virginHdClosurePrices,
  'virginHdClosure',
  true
);


// ------------------ GROUPED CATEGORIES ------------------

const RAW_GROUP = [
  { key: 'rawBundles', label: 'Raw Bundles', data: RAW_BUNDLE_DATA },
  { key: 'rawMicro', label: 'Raw Micro-rings (100g)', data: RAW_MICRO_DATA },
  { key: 'rawClip', label: 'Raw Seamless Clip-ins', data: RAW_CLIP_DATA },
  { key: 'rawTape', label: 'Raw Tape-ins', data: RAW_TAPE_DATA },
  { key: 'rawHdClosures', label: 'Raw HD Closures', data: RAW_HD_CLOSURE_DATA },
];

const VIRGIN_GROUP = [
  { key: 'virginBundles', label: 'Virgin Bundles', data: VIRGIN_BUNDLE_DATA },
  { key: 'virginMicro', label: 'Virgin Micro-links (100g)', data: VIRGIN_MICRO_DATA },
  { key: 'virginClip', label: 'Virgin Clip-ins (100g)', data: VIRGIN_CLIP_DATA },
  { key: 'virginTape', label: 'Virgin Tape-ins', data: VIRGIN_TAPE_DATA },
  { key: 'virginClosures', label: 'Virgin Closures (Transparent)', data: VIRGIN_CLOSURE_DATA },
  { key: 'virginHdClosures', label: 'Virgin HD Closures', data: VIRGIN_HD_CLOSURE_DATA },
];


// ------------------- COMPONENT -------------------

const HairPriceList = () => {
  const { addToCart } = useCart();
  const [topGroup, setTopGroup] = useState('raw'); // 'raw' | 'virgin'
  const [activeCategoryKey, setActiveCategoryKey] = useState(RAW_GROUP[0].key);
  const [activeSub, setActiveSub] = useState({});
  const [quantities, setQuantities] = useState({});

  const currentGroup = topGroup === 'raw' ? RAW_GROUP : VIRGIN_GROUP;
  const currentCategory =
    currentGroup.find((c) => c.key === activeCategoryKey) || currentGroup[0];

  const handleTopGroupChange = (group) => {
    setTopGroup(group);
    const groupArray = group === 'raw' ? RAW_GROUP : VIRGIN_GROUP;
    const firstCat = groupArray[0];
    setActiveCategoryKey(firstCat.key);
    const firstSub = Object.keys(firstCat.data)[0];
    setActiveSub((prev) => ({ ...prev, [firstCat.key]: firstSub }));
  };

  const handleCategorySelect = (key) => {
    setActiveCategoryKey(key);
    const cat = currentGroup.find((c) => c.key === key);
    if (cat) {
      const firstSub = Object.keys(cat.data)[0];
      setActiveSub((prev) => ({ ...prev, [key]: firstSub }));
    }
  };

  const handleQuantityChange = (id, qty) => {
    setQuantities({ ...quantities, [id]: qty < 1 ? 1 : qty > 10 ? 10 : qty });
  };

  const handleAddToCart = (id) => {
    const quantity = quantities[id] || 1;
    addToCart(id, quantity);
    setQuantities({ ...quantities, [id]: 1 });
  };

  useEffect(() => {
    // initialise default subcategory for initial category
    if (!activeSub[RAW_GROUP[0].key]) {
      const firstSub = Object.keys(RAW_GROUP[0].data)[0];
      setActiveSub({ [RAW_GROUP[0].key]: firstSub });
    }
  }, [activeSub]);

  const renderCategoryDescription = () => {
    // Raw Bundles
    if (topGroup === 'raw' && activeCategoryKey === 'rawBundles') {
      return (
        <p
          style={{
            textAlign: 'center',
            fontSize: '.9rem',
            color: '#6b5625',
            marginTop: '-0.2rem',
            marginBottom: '0.75rem',
            maxWidth: 780,
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: 1.35,
          }}
        >
          Our premium raw hair is 100% unprocessed human hair, cuticle-aligned and
          naturally full. Each price shown is per bundle. It can be bleached, dyed,
          or styled just like your own hair and offers long-lasting, soft, luxurious
          installs — perfect for clients who love body and fullness in every install.
        </p>
      );
    }

    // Virgin Bundles
    if (topGroup === 'virgin' && activeCategoryKey === 'virginBundles') {
      return (
        <p
          style={{
            textAlign: 'center',
            fontSize: '.9rem',
            color: '#6b5625',
            marginTop: '-0.2rem',
            marginBottom: '0.75rem',
            maxWidth: 780,
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: 1.35,
          }}
        >
          Our virgin hair bundles are high-quality human hair that has not been
          chemically processed, with textures refined for a consistent, beautiful
          finish. Each price shown is per bundle. Soft, versatile, and reliable,
          they are perfect for clients who want luxury results at a more accessible
          price point.
        </p>
      );
    }

    // Raw HD Closures
    if (activeCategoryKey === 'rawHdClosures') {
      return (
        <p
          style={{
            textAlign: 'center',
            fontSize: '.9rem',
            color: '#6b5625',
            marginTop: '-0.2rem',
            marginBottom: '0.75rem',
            maxWidth: 780,
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: 1.35,
          }}
        >
          Our raw HD lace closures are made with 100% unprocessed raw human hair for a
          flawless, natural finish. The ultra-thin HD lace melts seamlessly into all
          skin tones, creating an invisible hairline and scalp-like look. Each closure
          is full from root to tip, and can be dyed, bleached, or styled to match any
          bundles perfectly. Soft, durable, and tangle-free — ideal for sleek, natural
          installs.
        </p>
      );
    }

    // Virgin HD Closures
    if (activeCategoryKey === 'virginHdClosures') {
      return (
        <p
          style={{
            textAlign: 'center',
            fontSize: '.9rem',
            color: '#6b5625',
            marginTop: '-0.2rem',
            marginBottom: '0.75rem',
            maxWidth: 780,
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: 1.35,
          }}
        >
          Our Virgin HD lace is made from 100% virgin human hair, offering the perfect
          blend of softness, strength, and realism. The ultra-thin HD lace disappears
          into any skin tone, creating a flawless, natural hairline with a scalp-like
          finish. Each piece is full from root to tip and can be coloured, bleached,
          or heat-styled to your liking. Lightweight, breathable, and durable — ideal
          for seamless, long-lasting installs.
        </p>
      );
    }

    return null;
  };

  const currentSubKey = activeSub[activeCategoryKey];
  const currentData = currentCategory.data[currentSubKey] || [];

  return (
    <div
      className="container py-4"
      style={{
        maxWidth: 900,
        background: '#ffffff',
        borderRadius: '18px',
        boxShadow: '0 4px 24px #b49b6112',
        margin: '24px auto 28px auto',
      }}
    >
      <div
        style={{
          background: '#ffffff',
          border: '1.5px solid #e0e0e0',
          borderRadius: '10px',
          padding: '0.8rem 1rem',
          marginBottom: '0.6rem',
          textAlign: 'center',
          fontSize: '1.01em',
          boxShadow: '0 1.5px 7px #cab38a22',
        }}
      >
        <p style={{ margin: 0, color: '#2d2c1f', lineHeight: '1.35' }}>
          ⏱️ <strong>Delivery Time:</strong> All hair orders are delivered within{' '}
          <strong>7-14 working days</strong> from the order date.
        </p>
      </div>

      {/* Per-bundle pricing note */}
      <div
        style={{
          background: '#ffffff',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          padding: '0.55rem 0.9rem',
          marginBottom: '1.1rem',
          textAlign: 'center',
          fontSize: '.88rem',
          color: '#6b5625',
        }}
      >
        Prices shown for <strong>Raw Bundles</strong> and <strong>Virgin Bundles</strong>{' '}
        are per bundle. Adjust the quantity under each length if you need more than one bundle.
      </div>

      {/* TOP GROUP TOGGLE: RAW vs VIRGIN */}
      <div
        className="d-flex justify-content-center mb-3"
        style={{ gap: 10 }}
      >
        <button
          type="button"
          onClick={() => handleTopGroupChange('raw')}
          className="btn fw-bold"
          style={{
            minWidth: 130,
            borderRadius: 999,
            fontSize: '.97em',
            background:
              topGroup === 'raw'
                ? 'linear-gradient(90deg,#d7bb7b,#e4d1a7)'
                : '#f5e6be',
            color: topGroup === 'raw' ? '#7d6526' : '#b38607',
            border:
              topGroup === 'raw'
                ? '1.5px solid #bca75e'
                : '1.2px solid #eadcb3',
            boxShadow:
              topGroup === 'raw' ? '0 2.5px 12px #ebcb6e13' : undefined,
            transition: 'all 0.17s',
          }}
        >
          Raw Hair
        </button>
        <button
          type="button"
          onClick={() => handleTopGroupChange('virgin')}
          className="btn fw-bold"
          style={{
            minWidth: 130,
            borderRadius: 999,
            fontSize: '.97em',
            background:
              topGroup === 'virgin'
                ? 'linear-gradient(90deg,#d7bb7b,#e4d1a7)'
                : '#f5e6be',
            color: topGroup === 'virgin' ? '#7d6526' : '#b38607',
            border:
              topGroup === 'virgin'
                ? '1.5px solid #bca75e'
                : '1.2px solid #eadcb3',
            boxShadow:
              topGroup === 'virgin' ? '0 2.5px 12px #ebcb6e13' : undefined,
            transition: 'all 0.17s',
          }}
        >
          Virgin Hair
        </button>
      </div>

      {/* CATEGORY TABS (within selected group) */}
      <ul className="nav nav-pills mb-3" style={{ gap: 8, justifyContent: 'center' }}>
        {currentGroup.map((cat) => (
          <li className="nav-item" key={cat.key}>
            <button
              onClick={() => handleCategorySelect(cat.key)}
              className={`nav-link fw-bold ${
                activeCategoryKey === cat.key ? 'active' : ''
              }`}
              style={{
                background:
                  activeCategoryKey === cat.key
                    ? 'linear-gradient(90deg,#d7bb7b,#e4d1a7)'
                    : '#f5e6be',
                borderRadius: 8,
                color: activeCategoryKey === cat.key ? '#7d6526' : '#b38607',
                border:
                  activeCategoryKey === cat.key
                    ? '1.5px solid #bca75e'
                    : '1.2px solid #eadcb3',
                fontSize: '0.98em',
                letterSpacing: '.02em',
                boxShadow:
                  activeCategoryKey === cat.key
                    ? '0 2.5px 12px #ebcb6e13'
                    : undefined,
                transition: 'all 0.17s',
              }}
            >
              {cat.label}
            </button>
          </li>
        ))}
      </ul>

      {renderCategoryDescription()}

      {/* SUBCATEGORY BUTTONS (texture types) */}
      <div
        className="mb-3 d-flex flex-wrap gap-2"
        style={{ justifyContent: 'center' }}
      >
        {Object.keys(currentCategory.data).map((sub) => (
          <button
            key={sub}
            className={`btn ${
              currentSubKey === sub ? '' : 'btn-outline-warning'
            } fw-semibold`}
            style={{
              background:
                currentSubKey === sub
                  ? 'linear-gradient(90deg,#f4e2b4,#e9d6a0)'
                  : '#fff',
              color: '#958238',
              border:
                currentSubKey === sub
                  ? '1.3px solid #bca75e'
                  : '1.2px solid #edd7a1',
              borderRadius: 7,
              fontSize: '.95em',
              fontWeight: 600,
              padding: '5px 13px',
              minWidth: 108,
              boxShadow:
                currentSubKey === sub ? '0 2px 8px #ebcb6e15' : undefined,
              transition: 'all 0.13s',
            }}
            onClick={() =>
              setActiveSub((prev) => ({ ...prev, [activeCategoryKey]: sub }))
            }
          >
            {sub}
          </button>
        ))}
      </div>

      {/* LENGTH/PRICE PICKER GRID */}
      <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 row-cols-lg-7 g-2 g-md-3 justify-content-center">
        {currentData.map((opt) => (
          <div className="col" key={opt.id}>
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{
                background: '#fff',
                borderRadius: 10,
                border: '1.3px solid #f4e1b2',
                boxShadow: '0 2.5px 13px #cab38a11',
                minHeight: '54px',
                padding: '7px 4px 8px 4px',
                height: '100%',
                textAlign: 'center',
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '.91em',
                  marginBottom: '2px',
                  color: '#4a3e19',
                  lineHeight: 1.15,
                  minHeight: '17px',
                }}
              >
                {opt.length}
              </span>
              <span
                style={{
                  fontWeight: 600,
                  fontSize: '.95em',
                  color: '#2c2c2c',
                  marginBottom: '2.2px',
                }}
              >
                R {opt.price.toLocaleString()}
              </span>
              <div
                className="d-flex align-items-center gap-1"
                style={{ marginTop: '0.5px' }}
              >
                <input
                  type="number"
                  min={1}
                  max={10}
                  value={quantities[opt.id] || 1}
                  onChange={(e) =>
                    handleQuantityChange(opt.id, Number(e.target.value))
                  }
                  className="form-control"
                  style={{
                    width: '27px',
                    padding: '2.5px',
                    fontSize: '0.89em',
                    borderRadius: 5,
                    border: '1px solid #e0e0e0',
                    textAlign: 'center',
                    height: '22px',
                    background: '#ffffff',
                  }}
                />
                <button
                  type="button"
                  onClick={() => handleAddToCart(opt.id)}
                  className="btn btn-sm fw-bold"
                  style={{
                    padding: '2px 7px',
                    borderRadius: 5,
                    fontSize: '0.94em',
                    background:
                      'linear-gradient(90deg,#e2c77e,#f1e5c2 70%)',
                    border: 'none',
                    color: '#665315',
                    letterSpacing: '0.01em',
                    minHeight: '22px',
                    minWidth: '37px',
                    boxShadow: '0 1px 7px #cab38a16',
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { hairProducts };
export default HairPriceList;


















